<template>
  <v-layout row wrap pa-3>
		<v-flex xs12>
			<v-layout row wrap>
				<v-flex v-for="c in campaigns" :key="c.uid" xs12 pa-1>
					<v-card class="pa-2 elevation-4">
						<v-layout row wrap>
							<v-flex v-if="c.uid" xs4 md1>
								<div class="caption grey--text ">Campaign ID</div>
								<v-tooltip top>
									<span slot="activator">{{ c.uid | truncate(5, (c.uid.length>5 ? '..': '')) }}</span>
									<span>{{ c.uid }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.count" xs4 md1>
								<div class="caption grey--text ">Count</div>
								<v-tooltip top>
									<span slot="activator">{{ c.count }}</span>
									<span>{{ c.count }} Messages</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.message" xs4 md1>
								<div class="caption grey--text ">Message</div>
								<v-tooltip top>
									<span slot="activator">{{ c.message | truncate(5, (c.message.length>5 ? '..': '')) }}</span>
									<span>{{ c.message }}</span>
								</v-tooltip>
							</v-flex>
							<v-flex v-if="c.img" xs4 md1>
								<div class="caption grey--text ">Image</div>
								<v-tooltip top>
									<span slot="activator">{{ c.img | truncate(5, (c.img.length>5 ? '..': '')) }}</span>
									<span>
										<img :src="c.img" width="150">
									</span>
								</v-tooltip>
							</v-flex>
							<v-flex xs4 md1>
								<div class="caption grey--text ">Preparing</div>
								<v-tooltip v-if="!c.prepared" top>
									<span slot="activator">
										<v-progress-circular size="12" indeterminate color="primary"></v-progress-circular>
									</span>
									<span>Campaign preparing sending</span>
								</v-tooltip>
								<v-tooltip v-if="c.prepared" top>
									<span slot="activator">
										<v-icon size="18" color="primary">done</v-icon>
									</span>
									<span>Campaign preparing done</span>
								</v-tooltip>
							</v-flex>
							<v-flex xs4 md1>
								<div class="caption grey--text ">Queued</div>
								<v-tooltip v-if="!c.queed" top>
									<span slot="activator">
										<v-progress-circular size="12" indeterminate color="primary"></v-progress-circular>
									</span>
									<span>Campaign messages are being added to send Que</span>
								</v-tooltip>
								<v-tooltip v-if="c.queed" top>
									<span slot="activator">
										<v-icon size="18" color="primary">done</v-icon>
									</span>
									<span>Campaign messages are added to send Que</span>
								</v-tooltip>
							</v-flex>
							<v-flex xs4 md1>
								<div class="caption grey--text ">Sending</div>
								<v-tooltip v-if="c.queCount > 0" top>
									<span slot="activator">
										<v-progress-circular size="12" indeterminate color="primary"></v-progress-circular>
										{{ c.queCount }}
									</span>
									<span>Campaign messages are being sent</span>
								</v-tooltip>
								<v-tooltip v-if="c.prepared && c.queed && (c.queCount == 0 || !c.queCount)" top>
									<span slot="activator">
										<v-icon size="18" color="primary">done</v-icon>
									</span>
									<span>Campaign messages are all sent</span>
								</v-tooltip>
							</v-flex>
						</v-layout>
					</v-card>
				</v-flex>
			</v-layout>
		</v-flex>
  </v-layout>
</template>

<script>
import {firebase, db, auth, storageRef } from '@/fb';
import { getRandomInt, randomString, getCDate, check, uuid } from '@/customFunction';
import axios from 'axios';

export default {
	data() {
    return {
			campaigns:[],
		}
	},
	methods:{
		getCampaigns(){
			db.ref('waBulk')
			.on('value', snap=>{
				this.campaigns = snap.val()
				this.checkCampaignsQues()
			})
		},
		checkCampaignsQues(){
			for (const key in this.campaigns) {
				if (this.campaigns.hasOwnProperty(key)) {
					const c = this.campaigns[key];
					console.log('------------------------------------');
					console.log(c);
					console.log('------------------------------------');
					db.ref('waQuee')
					.orderByChild('uid')
					.equalTo(c.uid)
					.on('child_removed', ssnap=>{
						let msgKs = []
						let snap = ssnap.val()
						for (const key in snap) {
							if (snap.hasOwnProperty(key)) {
								const msg = snap[key];
								msgKs.push(msg)
							}
						}
						this.campaigns[key].queCount =  msgKs.length
					})
				}
			}
		},
	},
	created(){
		this.getCampaigns()
	}
}
</script>

<style>

</style>
